(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cy-legacy_flowbox"] && !Shopify.designMode) return;
  try {
    
  (function (d, id) {
    if (!window.flowbox) {
      var f = function () {
        f.q.push(arguments);
      };
      f.q = [];
      window.flowbox = f;
    }
    if (d.getElementById(id)) {
      return;
    }
    var s = d.createElement('script'),
      fjs = d.scripts[d.scripts.length - 1];
    s.id = id;
    s.async = true;
    s.src = ' https://connect.getflowbox.com/flowbox.js';
    fjs.parentNode.insertBefore(s, fjs);
  })(document, 'flowbox-js-embed');

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.flowbox) return;
    document.querySelectorAll('.js-flowbox-flow').forEach(function (elm) {
      window.flowbox('init', {
        container: elm,
        key: elm.dataset.key,
        locale: elm.dataset.locate,
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
